import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../lib/api";
import { ProductCard } from "../components/product/ProductCard";

export default function CategoryPage() {
  const { slug } = useParams();
  const [items, setItems] = useState([]);
  const [category, setCategory] = useState(null);

  useEffect(() => {
    api.get("/categories").then((r) => {
      const found = r.data.find((c) => c.slug === slug);
      setCategory(found);
    });
    api.get("/products", { params: { category: slug, limit: 120 } }).then((r) => setItems(r.data.items));
  }, [slug]);

  return (
    <div className="max-w-7xl mx-auto px-4 py-14" data-testid="category-page">
      <div className="mb-10">
        <div className="overline mb-3">Category</div>
        <h1 className="font-display text-4xl md:text-5xl font-semibold tracking-tight text-brand-navy">
          {category?.name || "Loading…"}
        </h1>
        <p className="mt-3 text-brand-muted text-sm max-w-2xl">{category?.short}</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
        {items.map((p) => <ProductCard key={p.id} product={p} />)}
      </div>
    </div>
  );
}
